import styled from 'styled-components';

import { space, tokens } from '../theme/tokens';

export type StatusIndicatorState = 'default' | 'success' | 'warning' | 'error' | 'off';

export const statusIndicatorColor: Record<StatusIndicatorState, string> = {
	default: tokens.info.icon,
	success: tokens.success.icon,
	warning: tokens.warning.icon,
	error: tokens.error.icon,
	off: tokens.icon.tertiary,
};

const Container = styled.span<{ $state: StatusIndicatorState }>`
	display: inline-block;
	box-sizing: border-box;
	width: ${space.xs}px;
	height: ${space.xs}px;
	flex-shrink: 0;
	border-radius: ${tokens.radius.full}px;
	background: ${(props) => statusIndicatorColor[props.$state]};
`;

export function StatusIndicator(props: { state?: StatusIndicatorState }) {
	const state = props.state ?? 'default';

	return <Container $state={state} />;
}
